module.exports = __webpack_public_path__ + "img/sp2.ea482e2b.svg";